import React from 'react';
import PropTypes from 'prop-types';

// import css from './style.scss';

/* eslint-disable react/jsx-filename-extension */

let CodeMirror;

class CodeEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      lineNumbers: this.props.lineNumbers,
      mode: this.props.mode,
      readOnly: this.props.readOnly,
      className: this.props.className,
      code: this.props.code || '{}',
      value: this.props.code,
    };

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    if (this.props.changeOnBlur) CodeMirror = require('react-codemirror2').UnControlled;
    else CodeMirror = require('react-codemirror2').Controlled;

    // see mode list : https://codemirror.net/mode/
    require('codemirror/mode/htmlmixed/htmlmixed');
    require('codemirror/mode/javascript/javascript');
    // What the `autoRefresh` option needs: an editor mounted hidden -- the
    // embed modal is laid out once open -- measures nothing and draws one
    // line until it is refreshed in sight.
    require('codemirror/addon/display/autorefresh');

    // CodeMirror is only required here, after the first render, which drew
    // nothing without it. Nothing else re-renders this component -- the embed
    // modal mounts it once and leaves it -- so it asks for the render that
    // draws the editor itself.
    this.setState({ editorLoaded: true });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.code !== this.props.code) {
      this.setState({
        code: this.props.code,
      });
    }
  }

  onChange = (value) => {
    this.setState({ value });
    if (!this.props.changeOnBlur) {
      this.props.onChange(value);
    }
  }

  onBlur = () => {
    if (this.props.changeOnBlur) {
      this.props.onChange(this.state.value);
    }
  }

  render() {
    const options = {
      lineNumbers: this.state.lineNumbers,
      mode: this.state.mode,
      readOnly: this.state.readOnly,
      indentWithTabs: true,
      autoRefresh: true
    };

    const formattedCode = this.props.mode === 'javascript' ? JSON.stringify(JSON.parse(this.state.code), null, 2) : this.state.code;

    return (
      <div>
        <div className="text-sm">
          {CodeMirror ? (
            <CodeMirror
              value={formattedCode}
              onBlur={this.onBlur}
              onChange={(editor, data, value) => this.onChange(value, editor, data)}
              options={options}
              editorDidMount={editor => { this.instance = editor; this.instance.refresh() }}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

CodeEditor.propTypes = {
  label: PropTypes.string,
  mode: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  changeOnBlur: PropTypes.bool,
  lineNumbers: PropTypes.bool,
  readOnly: PropTypes.bool,
  code: PropTypes.string,
  className: PropTypes.string,
};

CodeEditor.defaultProps = {
  label: undefined,
  mode: 'javascript',
  changeOnBlur: false,
  lineNumbers: true,
  readOnly: false,
  code: '{}',
  onChange: () => {},
}

export default CodeEditor;
